import { Component, OnInit, Input, TemplateRef, Output, EventEmitter, ChangeDetectorRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { ExternalMarketing } from '../../../shared/models/external-marketing';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

export enum Timeline {
  BOV = 1,
  Premarketing = 2,
  Marketing = 3,
  DealMaking = 4,
  Closed = 5
}

@Component({
  selector: 'app-external-marketing-list',
  templateUrl: './external-marketing-list.component.html'
})
export class ExternalMarketingListComponent implements OnInit {

  @Input() propertyId: number;
  @Input() externalMarketingId: number;
  @Input() property: any;
  @Input() externalMarketingType: any;
  @Output() update = new EventEmitter();
  @Input() isFromDashboard: boolean;
  //externalMarketingType: 
  modalRef: BsModalRef;
  removeModalRef: BsModalRef;
  lstExternalMarketing = [] as ExternalMarketing[];
  marketing: any;
  removeItemId: number;
  table: DataTableDirective;
  dtOptions = {};
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  documentsList = [];
  docListModel: BsModalRef;
  hideSource = false as boolean;
  showNodata = false as boolean;
  selectedTimelineId: number;
  timeline = Timeline;

  constructor(private modalService: BsModalService,
    private _dashboardService: DashboardService,
    public _validationService: ValidationService,
    private _toastService: ToastService,
    private _changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,) { }

  ngOnInit() {
    this.selectedTimelineId = this.property.PropertyStatus == 'BOV' ? this.timeline.BOV : (this.property.PropertyStatus == 'Pre-Marketing' ? this.timeline.Premarketing :
      (this.property.PropertyStatus == 'Available' || this.property.PropertyStatus == 'Not Available' ||
        this.property.PropertyStatus == 'Off-Market' ? this.timeline.Marketing :
        (this.property.PropertyStatus == 'Sold' ? this.timeline.Closed : this.timeline.DealMaking)));
    this.showNodata = this.selectedTimelineId >= this.timeline.Marketing ? false : true;

    this.geMaketingTypeListById(this.externalMarketingId);
    if (this.externalMarketingId == 4052 || this.externalMarketingId == 4053) { // Calls and Emails
      this.hideSource = true;
    }
    else {
      this.hideSource = false;
    }
  }

  onAddOrEdit(template: TemplateRef<any>, classes, marketing = null) {
    if (marketing) {
      this.marketing = Object.assign({}, marketing)
    }
    else {
      this.marketing = null;
    }
    this._changeDetectorRef.detectChanges();
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  close() {
    this.modalRef.hide();
  }

  save(data) {
    this.update.emit({ id: this.externalMarketingId })
    this.dtElement.dtInstance.then(x => x.draw(false));
    this._toastService.addToast({
      title: 'Success', msg:
        this.externalMarketingType.description + ' saved Successfully', timeout:
        5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
    });
    this.close()
  }

  geMaketingTypeListById(id) {
    this.externalMarketingId = id;
    this.lstExternalMarketing = [];
    if (id != undefined) {
      //this._dashboardService.getExternalMarketingListByTypeId(id, this.propertyId).subscribe(data => {
      //    data.forEach(item => {
      //        item.FromDate = this._validationService.convertUTCDateToLocalDate(item.FromDate)
      //        item.ToDate = this._validationService.convertUTCDateToLocalDate(item.ToDate)
      //        this.lstExternalMarketing.push(item);
      //    });
      //    let count = data.map(x => x.Value).reduce((a, b) => a + b, 0);
      //    this.update.emit({ id: id, count: count })
      //})
      this.bindTable()
    }
  }

  IsLoading = false;
  bindTable() {

    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[1, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          PropertyId: that.propertyId,
          ExternalMarketigTypeId: that.externalMarketingId
        }
        const httpHeader = this._validationService.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/Property/getExteranalMarketingListByTypeId',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            this.lstExternalMarketing = resp.data ? resp.data : [];
            let count = resp.data.map(x => x.Value).reduce((a, b) => a + b, 0);

            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: [{ data: 'Source' },
      { data: 'Source' },
      { data: 'FromDate' },
      { data: 'Value', },
      { data: 'ModifiedDate' }]
    };
  }

  removeModel(template: TemplateRef<any>, classes, id) {
    this.removeModalRef = this.modalService.show(template, { class: classes });
    this.removeItemId = id;
  }

  removeExternalMarketing() {
    this._dashboardService.removeExternalMarketing(this.removeItemId).subscribe(res => {
      if (res) {
        this.update.emit({ id: this.externalMarketingId })
        this.dtElement.dtInstance.then(x => x.draw(false));
        this._toastService.addToast({
          title: 'Success', msg:
            this.externalMarketingType.description + ' removed successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'Failed to remove ' + this.externalMarketingType.description,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    })
  }

  docList(template: TemplateRef<any>, classes, marketing) {
    this.documentsList = marketing.LstDocuments;
    this.docListModel = this.modalService.show(template, { class: classes });
  }

  docClose() {
    this.docListModel.hide();
  }
}
